export default "__VITE_ASSET__cxdPNK29__"